export const getPostItems = <T>({ items }: { items: T }): T => {
  return items || null;
};

export const splitContentByParagraph = (content: string): string[] => {
  return content
    .replace(/<ul>/g, '<p><ul>')
    .replace(/<\/ul>/g, '</ul></p>')
    .replace(/<ol>/g, '<p><ol>')
    .replace(/<\/ol>/g, '</ol></p>')
    .replace(/<h1>/g, '<p><h1>')
    .replace(/<\/h1>/g, '</h1></p>')
    .replace(/<h2>/g, '<p><h2>')
    .replace(/<\/h2>/g, '</h2></p>')
    .replace(/<h3>/g, '<p><h3>')
    .replace(/<\/h3>/g, '</h3></p>')
    .replace(/<h4>/g, '<p><h4>')
    .replace(/<\/h4>/g, '</h4></p>')
    .replace(/<h5>/g, '<p><h5>')
    .replace(/<\/h5>/g, '</h5></p>')
    .replace(/<h6>/g, '<p><h6>')
    .replace(/<\/h6>/g, '</h6></p>')
    .replace(/<figure[^>]*>/g, '<p>')
    .replace(/<\/figure>/g, '</p>')
    .replace(/<figcaption[^>]*>/g, '<span data-figcaption>')
    .replace(/<\/figcaption>/g, '</span>')
    .split(/<\s*p[^>]*>/gim);
};

export const getParagraphOne = (content: string): string => {
  const paragraphOne =
    splitContentByParagraph(content).find(
      (paragraph) => paragraph.includes('</p>') && !paragraph.includes('<img'),
    ) || '';
  return paragraphOne.replace(/<[^>]*>/g, '');
};
